import { render, staticRenderFns } from "./TraxTrainingProgramCrud.vue?vue&type=template&id=2c70310c"
import script from "./TraxTrainingProgramCrud.vue?vue&type=script&lang=js"
export * from "./TraxTrainingProgramCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports